module.exports = __webpack_public_path__ + "static/media/red-star-left@2x.8b0b4f9c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/red-star-left@2x.png
 ** module id = 1992
 ** module chunks = 50
 **/